<template>
  <div>
    <v-card height="68vh" class="mx-auto">
      <v-card-title
        style="background-color: #82a1d0; position: sticky; top: 0; z-index: 1"
        background-color="primary"
        class="d-flex justify-space-between"
      >
        <v-text-field
          dense
          solo
          v-model="localSearch"
          append-icon="mdi-magnify"
          :label="$tc('commons.search')"
          single-line
          hide-details
          class="search"
        />
        <v-col cols="auto my-n2">
          <v-row>
            <!-- Título -->
            <h3 class="secondary--text mr-4 my-auto" v-show="title">
              {{ title }}
            </h3>
            <v-row class="justify-start ma-0" :class="{ border: showAdd }">
              <!-- Botón de Refresh -->
              <v-col cols="auto pa-0">
                <v-tooltip bottom v-if="showRefresh">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="refreshItems"
                      class="btn-table ma-1"
                      small
                    >
                      <v-icon
                        :class="{ loader: loading4 }"
                        :loading="loading4"
                        :disabled="loading4"
                        id="icon-add"
                        class="mx-auto"
                        size="19"
                      >
                        fas fa-sync-alt
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $tc("commons.refresh") }}</span>
                </v-tooltip>
              </v-col>

              <!-- Botón de Añadir -->
              <v-col cols="auto pa-0">
                <div v-show="showAdd">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="white"
                        dark
                        icon
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          size="20"
                          class="mx-auto"
                          id="icon-add"
                          v-bind="attrs"
                          v-on="on"
                          @click="openDialog('add')"
                        >
                          fas fa-plus
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("commons.add") }}</span>
                  </v-tooltip>
                </div>
              </v-col>

              <!-- Botón de Reutilizar segmento -->
              <v-col cols="auto pa-0">
                <div v-show="showReuse">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="white"
                        dark
                        icon
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          size="20"
                          class="mx-auto"
                          id="icon-add"
                          v-bind="attrs"
                          v-on="on"
                          @click="openDialog('reuse')"
                        >
                          fas fa-recycle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("schedules.reuseSegment") }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
      </v-card-title>
      <div v-if="filteredItems.length === 0" class="no-search">
        No se encontraron {{ title }}.
      </div>
      <div
        class="d-grid pt-4 card_container"
        align="center"
        justify="center"
        v-else
      >
        <v-row class="mx-2">
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="4"
            xl="3"
            v-for="(item, index) in filteredItems"
            :key="index"
          >
            <v-card class="card" :max-height="heightCard">
              <div class="div-container-card" @click="goToItem(item)">
                <v-card-title class="justify-center card-title">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div style="overflow-y: hidden">
                        <span v-bind="attrs" v-on="on">
                          <p
                            style="
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                            "
                          >
                            {{ item.name }}
                          </p>
                        </span>
                      </div>
                    </template>
                    <span> {{ item.name }}</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-subtitle class="d-flex flex-column">
                  <span> {{ subtitle }} {{ item.subtitle }}</span>
                  <div class="d-flex align-center">
                    <v-chip
                      v-for="(sub, i) in item.chips && item.chips.slice(0, 3)"
                      :key="i"
                      class="chips"
                    >
                      <div class="truncate-chip">{{ sub }}</div>
                    </v-chip>
                    <span
                      v-if="item.chips && item.chips.length > 3"
                      class="grey--text text-caption chips"
                    >
                      (+{{ item.chips.length - 3 }})
                    </span>
                  </div>
                </v-card-subtitle>
              </div>
              <v-card-actions>
                <v-spacer />

                <v-tooltip bottom v-if="operator">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn icon>
                        <v-icon
                          id="icon-edit"
                          @click="openDialog('changedPass', item, $event)"
                        >
                          fas fa-key
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("commons.changedPass") }}</span>
                </v-tooltip>

                <v-tooltip bottom v-if="showInicializeCC">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn icon>
                        <v-icon
                          id="icon-edit"
                          @click="openDialog('inicializeCC', item, $event)"
                        >
                          fas fa-angle-double-up
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("commons.initializeMassiveCC") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn
                        class="center"
                        v-show="showEdit"
                        :disabled="shouldShowDeleteButton(item)"
                        :plain="shouldShowDeleteButton(item)"
                        icon
                      >
                        <v-icon
                          id="icon-edit"
                          @click="openDialog('edit', item)"
                        >
                          fas fa-pen
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("commons.edit") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn class="center" v-show="showDelRelation" icon>
                        <v-icon
                          id="icon-delete-relation"
                          @click="openDialog('deleteRelation', item)"
                        >
                          fas fa-trash
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("commons.deleteRelation") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn
                        class="center"
                        v-show="showDelete"
                        :disabled="shouldShowDeleteButton(item)"
                        icon
                        :plain="shouldShowDeleteButton(item)"
                      >
                        <v-icon
                          id="icon-delete"
                          @click="openDialog('delete', item)"
                        >
                          fas fa-trash
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("commons.delete") }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
    </v-card>
    <div v-if="showPagination" class="mt-2">
      <v-pagination
        v-model="currentPage"
        :length="Math.ceil(items.length / itemsPerPage)"
        prev-icon="mdi-chevron-left"
        next-icon="mdi-chevron-right"
        hide-delimiter-background
        :items-per-page="itemsPerPage"
        :max="Math.min(10, Math.ceil(items.length / itemsPerPage))"
        :total-visible="Math.min(10, Math.ceil(items.length / itemsPerPage))"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import Loader from "./Loader.vue";
import ToolbarTitles from "./ToolbarTitles.vue";

export default {
  components: { ToolbarTitles, Loader },
  props: {
    showDelRelation: {
      type: Boolean,
      default: false,
    },
    showReuse: {
      type: Boolean,
      default: false,
    },
    showInicializeCC: {
      type: Boolean,
      default: false,
    },
    showRefresh: {
      type: Boolean,
      default: false,
    },
    items: Array,
    heightCard: {
      type: String,
      default: "100px",
    },
    openDialog: Function,
    title: String,
    subtitle: String,
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    itemsPerPage: {
      type: Number,
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
    operator: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSearch: "",
      isLoading: this.showLoader,
      currentPage: 1,
      loader: null,
      loading4: false,
    };
  },
  computed: {
    filteredItems() {
      const filtered = this.localSearch
        ? this.items.filter((item) =>
            item.name.toLowerCase().includes(this.localSearch.toLowerCase()),
          )
        : this.items;

      if (this.showPagination && this.itemsPerPage) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return filtered.slice(start, start + this.itemsPerPage);
      }

      return filtered;
    },
  },
  methods: {
    async refreshItems() {
      this.loading4 = true;
      try {
        await this.$emit("refreshItems");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },
    shouldShowDeleteButton(item) {
      return item.editable === undefined ? false : item.editable;
    },
    goToItem(item) {
      if (this.showLoader) {
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading = false;
          this.$emit("goToItem", item);
        }, 1000);
      } else {
        this.$emit("goToItem", item);
      }
    },
  },
};
</script>

<style scoped>
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.search {
  max-width: 500px;
}
.chips {
  margin: 2px !important;
}
.truncate-chip {
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.card-title {
  max-width: 350px !important;
  font-weight: bold !important;
  text-transform: uppercase !important;
}
.card {
  margin-bottom: 15px;
  max-width: 350px;
  max-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border: 3px outset #9cb6da !important;
}
.card_container {
  height: 80%;
  max-width: 100%;
  overflow-y: scroll;
  scrollbar-width: unset;
}
.card:hover {
  border: 1px solid #82a1d0 !important;
  transform: translateY(-5px);
  box-shadow: -1px 1px 10px 1px rgba(122, 122, 122, 0.75) !important;
}
.div-container-card {
  cursor: pointer;
  margin: 3px;
  min-height: 35%;
}
.no-search {
  text-align: center !important;
  height: 130px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
#icon-delete-relation {
  color: #e48131;
  font-size: 20px;
}
</style>
